import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, Directive, HostBinding, TemplateRef, ContentChild, NgModule } from '@angular/core';
import * as i3 from 'ngx-ui-tour-core';
import { TourService, ScrollingUtil, TourState, TourHotkeyListenerComponent, TourBackdropService, TourModule } from 'ngx-ui-tour-core';
import * as i1 from '@angular/material/menu';
import { MatMenu, MAT_MENU_SCROLL_STRATEGY, MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import { Overlay } from '@angular/cdk/overlay';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i4 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { first } from 'rxjs/operators';

class NgxmTourService extends TourService {
}
NgxmTourService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NgxmTourService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NgxmTourService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NgxmTourService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NgxmTourService, decorators: [{
            type: Injectable
        }] });

function scrollFactory(overlay, tourService) {
    return () => {
        const step = tourService.currentStep, scrollStrategies = overlay.scrollStrategies, disablePageScrolling = !!step.disablePageScrolling;
        return disablePageScrolling ? scrollStrategies.block() : scrollStrategies.reposition();
    };
}
class TourAnchorOpenerComponent {
    constructor() {
        this.menu = new MatMenu(undefined, undefined, {
            xPosition: 'after',
            yPosition: 'below',
            overlapTrigger: true,
            backdropClass: ''
        });
    }
}
TourAnchorOpenerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourAnchorOpenerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TourAnchorOpenerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: TourAnchorOpenerComponent, selector: "tour-anchor-opener", inputs: { menu: "menu" }, providers: [{
            provide: MAT_MENU_SCROLL_STRATEGY,
            useFactory: scrollFactory,
            deps: [Overlay, NgxmTourService]
        }], viewQueries: [{ propertyName: "trigger", first: true, predicate: MatMenuTrigger, descendants: true }], ngImport: i0, template: `
        <span [matMenuTriggerFor]="menu" [matMenuTriggerRestoreFocus]="false" #trigger="matMenuTrigger"></span>
    `, isInline: true, styles: [":host{display:none}\n"], directives: [{ type: i1.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourAnchorOpenerComponent, decorators: [{
            type: Component,
            args: [{
                    providers: [{
                            provide: MAT_MENU_SCROLL_STRATEGY,
                            useFactory: scrollFactory,
                            deps: [Overlay, NgxmTourService]
                        }],
                    selector: 'tour-anchor-opener',
                    styles: [
                        `
            :host {
                display: none;
            }
        `
                    ],
                    template: `
        <span [matMenuTriggerFor]="menu" [matMenuTriggerRestoreFocus]="false" #trigger="matMenuTrigger"></span>
    `
                }]
        }], propDecorators: { menu: [{
                type: Input
            }], trigger: [{
                type: ViewChild,
                args: [MatMenuTrigger]
            }] } });

class TourStepTemplateService {
}
TourStepTemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourStepTemplateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TourStepTemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourStepTemplateService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourStepTemplateService, decorators: [{
            type: Injectable
        }] });

class TourAnchorMatMenuDirective {
    constructor(componentFactoryResolver, injector, viewContainer, element, tourService, tourStepTemplate, tourBackdrop) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.viewContainer = viewContainer;
        this.element = element;
        this.tourService = tourService;
        this.tourStepTemplate = tourStepTemplate;
        this.tourBackdrop = tourBackdrop;
        this.opener = this.viewContainer.createComponent(this.componentFactoryResolver.resolveComponentFactory(TourAnchorOpenerComponent)).instance;
    }
    ngOnInit() {
        this.tourService.register(this.tourAnchor, this);
    }
    ngOnDestroy() {
        this.tourService.unregister(this.tourAnchor);
    }
    // noinspection JSUnusedGlobalSymbols
    showTourStep(step) {
        var _a, _b;
        const htmlElement = this.element.nativeElement;
        this.isActive = true;
        this.tourStepTemplate.templateComponent.step = step;
        // Ignore step.placement
        if (!step.disableScrollToAnchor) {
            ScrollingUtil.ensureVisible(htmlElement);
        }
        const trigger = this.opener.trigger;
        trigger._element = this.element;
        const menu = this.tourStepTemplate.templateComponent.tourStep;
        trigger.menu = menu;
        menu.xPosition = ((_a = step.placement) === null || _a === void 0 ? void 0 : _a.xPosition) || 'after';
        menu.yPosition = ((_b = step.placement) === null || _b === void 0 ? void 0 : _b.yPosition) || 'below';
        menu.hasBackdrop = !!step.closeOnOutsideClick;
        trigger.ngAfterContentInit();
        trigger.openMenu();
        if (step.enableBackdrop) {
            this.tourBackdrop.show(this.element, !step.disablePageScrolling);
        }
        else {
            this.tourBackdrop.close();
        }
        step.prevBtnTitle = step.prevBtnTitle || 'Prev';
        step.nextBtnTitle = step.nextBtnTitle || 'Next';
        step.endBtnTitle = step.endBtnTitle || 'End';
        if (this.menuCloseSubscription) {
            this.menuCloseSubscription.unsubscribe();
        }
        this.menuCloseSubscription = trigger.menuClosed
            .pipe(first())
            .subscribe(() => {
            if (this.tourService.getStatus() !== TourState.OFF) {
                this.tourService.end();
            }
            this.tourBackdrop.close();
        });
    }
    hideTourStep() {
        this.isActive = false;
        if (this.menuCloseSubscription) {
            this.menuCloseSubscription.unsubscribe();
        }
        this.opener.trigger.closeMenu();
        if (this.tourService.getStatus() === TourState.OFF) {
            this.tourBackdrop.close();
        }
    }
}
TourAnchorMatMenuDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourAnchorMatMenuDirective, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ElementRef }, { token: NgxmTourService }, { token: TourStepTemplateService }, { token: i3.TourBackdropService }], target: i0.ɵɵFactoryTarget.Directive });
TourAnchorMatMenuDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: TourAnchorMatMenuDirective, selector: "[tourAnchor]", inputs: { tourAnchor: "tourAnchor" }, host: { properties: { "class.touranchor--is-active": "this.isActive" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourAnchorMatMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tourAnchor]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ElementRef }, { type: NgxmTourService }, { type: TourStepTemplateService }, { type: i3.TourBackdropService }]; }, propDecorators: { tourAnchor: [{
                type: Input
            }], isActive: [{
                type: HostBinding,
                args: ['class.touranchor--is-active']
            }] } });

class TourStepTemplateComponent extends TourHotkeyListenerComponent {
    constructor(tourStepTemplateService, tourService) {
        super(tourService);
        this.tourStepTemplateService = tourStepTemplateService;
        this.tourService = tourService;
        this.step = {};
    }
    ngAfterViewInit() {
        this.tourStepTemplateService.templateComponent = this;
    }
}
TourStepTemplateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourStepTemplateComponent, deps: [{ token: TourStepTemplateService }, { token: NgxmTourService }], target: i0.ɵɵFactoryTarget.Component });
TourStepTemplateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: TourStepTemplateComponent, selector: "tour-step-template", inputs: { stepTemplate: "stepTemplate" }, queries: [{ propertyName: "stepTemplateContent", first: true, predicate: TemplateRef, descendants: true }], viewQueries: [{ propertyName: "tourStep", first: true, predicate: MatMenu, descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-menu [overlapTrigger]=\"false\" class=\"tour-step\">\r\n    <ng-container\r\n        *ngTemplateOutlet=\"\r\n                    stepTemplate || stepTemplateContent || defaultTemplate;\r\n                    context: { step: step }\r\n                \"\r\n    ></ng-container>\r\n</mat-menu>\r\n\r\n<ng-template #defaultTemplate let-step=\"step\">\r\n    <mat-card (click)=\"$event.stopPropagation()\">\r\n        <mat-card-title>\r\n            <div class=\"title-text\">{{step?.title}}</div>\r\n            <button\r\n                mat-button\r\n                mat-icon-button\r\n                (click)=\"tourService.end()\"\r\n                class=\"close\"\r\n            >\r\n                <mat-icon>close</mat-icon>\r\n            </button>\r\n        </mat-card-title>\r\n\r\n        <mat-card-content [innerHTML]=\"step?.content\"></mat-card-content>\r\n\r\n        <mat-card-actions align=\"end\">\r\n            <button\r\n                mat-button\r\n                class=\"prev\"\r\n                [disabled]=\"!tourService.hasPrev(step)\"\r\n                (click)=\"tourService.prev()\"\r\n            >\r\n                <mat-icon>chevron_left</mat-icon> {{step?.prevBtnTitle}}\r\n            </button>\r\n            <button\r\n                mat-button\r\n                class=\"next\"\r\n                *ngIf=\"tourService.hasNext(step) && !step.goToNextOnAnchorClick\"\r\n                (click)=\"tourService.next()\"\r\n            >\r\n                {{step?.nextBtnTitle}} <mat-icon>chevron_right</mat-icon>\r\n            </button>\r\n            <button\r\n                mat-button\r\n                (click)=\"tourService.end()\"\r\n                *ngIf=\"!tourService.hasNext(step)\"\r\n            >\r\n                {{step?.endBtnTitle}}\r\n            </button>\r\n        </mat-card-actions>\r\n    </mat-card>\r\n</ng-template>\r\n", styles: ["::ng-deep .tour-step .mat-menu-content{padding:0!important}mat-card{min-width:200px}mat-card-actions{justify-content:space-between}mat-card-actions button{margin:0}mat-card-actions button.prev{padding-left:4px}mat-card-actions button.next{padding-right:4px}mat-card-title{display:flex;align-items:center;justify-content:space-between}mat-card-title .title-text{line-height:24px;font-size:22px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}mat-card-title button.close{margin:-8px -8px -8px 0}\n"], components: [{ type: i1.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { type: i4.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { type: i5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i6.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i7.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i4.MatCardTitle, selector: "mat-card-title, [mat-card-title], [matCardTitle]" }, { type: i4.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { type: i4.MatCardActions, selector: "mat-card-actions", inputs: ["align"], exportAs: ["matCardActions"] }, { type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourStepTemplateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tour-step-template', template: "<mat-menu [overlapTrigger]=\"false\" class=\"tour-step\">\r\n    <ng-container\r\n        *ngTemplateOutlet=\"\r\n                    stepTemplate || stepTemplateContent || defaultTemplate;\r\n                    context: { step: step }\r\n                \"\r\n    ></ng-container>\r\n</mat-menu>\r\n\r\n<ng-template #defaultTemplate let-step=\"step\">\r\n    <mat-card (click)=\"$event.stopPropagation()\">\r\n        <mat-card-title>\r\n            <div class=\"title-text\">{{step?.title}}</div>\r\n            <button\r\n                mat-button\r\n                mat-icon-button\r\n                (click)=\"tourService.end()\"\r\n                class=\"close\"\r\n            >\r\n                <mat-icon>close</mat-icon>\r\n            </button>\r\n        </mat-card-title>\r\n\r\n        <mat-card-content [innerHTML]=\"step?.content\"></mat-card-content>\r\n\r\n        <mat-card-actions align=\"end\">\r\n            <button\r\n                mat-button\r\n                class=\"prev\"\r\n                [disabled]=\"!tourService.hasPrev(step)\"\r\n                (click)=\"tourService.prev()\"\r\n            >\r\n                <mat-icon>chevron_left</mat-icon> {{step?.prevBtnTitle}}\r\n            </button>\r\n            <button\r\n                mat-button\r\n                class=\"next\"\r\n                *ngIf=\"tourService.hasNext(step) && !step.goToNextOnAnchorClick\"\r\n                (click)=\"tourService.next()\"\r\n            >\r\n                {{step?.nextBtnTitle}} <mat-icon>chevron_right</mat-icon>\r\n            </button>\r\n            <button\r\n                mat-button\r\n                (click)=\"tourService.end()\"\r\n                *ngIf=\"!tourService.hasNext(step)\"\r\n            >\r\n                {{step?.endBtnTitle}}\r\n            </button>\r\n        </mat-card-actions>\r\n    </mat-card>\r\n</ng-template>\r\n", styles: ["::ng-deep .tour-step .mat-menu-content{padding:0!important}mat-card{min-width:200px}mat-card-actions{justify-content:space-between}mat-card-actions button{margin:0}mat-card-actions button.prev{padding-left:4px}mat-card-actions button.next{padding-right:4px}mat-card-title{display:flex;align-items:center;justify-content:space-between}mat-card-title .title-text{line-height:24px;font-size:22px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}mat-card-title button.close{margin:-8px -8px -8px 0}\n"] }]
        }], ctorParameters: function () { return [{ type: TourStepTemplateService }, { type: NgxmTourService }]; }, propDecorators: { tourStep: [{
                type: ViewChild,
                args: [MatMenu]
            }], stepTemplate: [{
                type: Input
            }], stepTemplateContent: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

class TourMatMenuModule {
    static forRoot() {
        return {
            ngModule: TourMatMenuModule,
            providers: [
                TourStepTemplateService,
                TourBackdropService,
                TourService,
                NgxmTourService
            ]
        };
    }
}
TourMatMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourMatMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TourMatMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourMatMenuModule, declarations: [TourAnchorMatMenuDirective,
        TourStepTemplateComponent,
        TourAnchorOpenerComponent], imports: [CommonModule,
        TourModule,
        MatMenuModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule], exports: [TourAnchorMatMenuDirective,
        TourStepTemplateComponent,
        TourModule] });
TourMatMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourMatMenuModule, imports: [[
            CommonModule,
            TourModule,
            MatMenuModule,
            MatCardModule,
            MatButtonModule,
            MatIconModule
        ], TourModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TourMatMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TourAnchorMatMenuDirective,
                        TourStepTemplateComponent,
                        TourAnchorOpenerComponent
                    ],
                    exports: [
                        TourAnchorMatMenuDirective,
                        TourStepTemplateComponent,
                        TourModule
                    ],
                    imports: [
                        CommonModule,
                        TourModule,
                        MatMenuModule,
                        MatCardModule,
                        MatButtonModule,
                        MatIconModule
                    ]
                }]
        }] });

/*
 * Public API Surface of ngx-ui-tour-md-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TourAnchorMatMenuDirective, TourMatMenuModule, NgxmTourService as TourService, TourStepTemplateComponent };
